import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IRecenziiSectiuni, IRecenziiSectiuniPayload } from './recenzii.interface';

@Injectable({
    providedIn: 'root'
})
export class RecenziiService {
    private token!: string;
    private httpOptions: any;

    private basePath = environment.interop.basePath;
    private getRecenziiDTURL =
        this.basePath + environment.interop.platform.nomenclatoare.recenzii.getRecenzii;
    private getRecenziiSectiuniURL = this.basePath + environment.interop.platform.nomenclatoare.recenzii.getRecenziiSectiuni;
    private markSpamRecenzieURL = this.basePath + environment.interop.platform.nomenclatoare.recenzii.markSpam;
    private removeSpamRecenzieURL = this.basePath + environment.interop.platform.nomenclatoare.recenzii.removeSpam;

    constructor(private http: HttpClient) { }

    getRecenziiDT() {
        return this.http.get(this.getRecenziiDTURL);
    }

    getRecenziiSectiuni(payload: IRecenziiSectiuniPayload) {
        return this.http.post<{ errors: boolean; data: IRecenziiSectiuni[]; status_code: number }>(this.getRecenziiSectiuniURL, { filters: payload });
    }

    markSpamRecenzie(id: number, obs: string) {
        return this.http.post(this.markSpamRecenzieURL + id, { recenzie_obs: obs });
    }

    removeSpamRecenzie(id: number) {
        return this.http.put(this.removeSpamRecenzieURL + id, {});
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
